/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/tractor_medium'
export default icon
